import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/hl`;
const HLAuthContext = createContext(null);

export function HLAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("hl_token");
    if (token) {
      axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
        .then(res => setUser({ ...res.data, token }))
        .catch(() => { localStorage.removeItem("hl_token"); setUser(false); })
        .finally(() => setLoading(false));
    } else {
      setUser(false);
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem("hl_token", data.token);
    setUser(data);
    return data;
  };

  const register = async (fields) => {
    const { data } = await axios.post(`${API}/auth/register`, fields);
    localStorage.setItem("hl_token", data.token);
    setUser(data);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("hl_token");
    setUser(false);
  };

  const api = axios.create({ baseURL: API });
  api.interceptors.request.use(config => {
    const t = localStorage.getItem("hl_token");
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
  });

  return (
    <HLAuthContext.Provider value={{ user, loading, login, register, logout, api }}>
      {children}
    </HLAuthContext.Provider>
  );
}

export const useHLAuth = () => useContext(HLAuthContext);
